var React = require('react');

function Ethernet (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 208v224a16 16 0 0 1-16 16h-80V320h-32v128h-64V320h-32v128h-64V320h-32v128h-64V320H96v128H16a16 16 0 0 1-16-16V208a16 16 0 0 1 16-16h48v-48a16 16 0 0 1 16-16h48V80a16 16 0 0 1 16-16h224a16 16 0 0 1 16 16v48h48a16 16 0 0 1 16 16v48h48a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M192 448h32V320h-32zm-96 0h32V320H96zm192 0h32V320h-32zm96-128v128h32V320z","className":"fa-primary","key":2})]);
}

Ethernet.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Ethernet;

Ethernet.default = Ethernet;
